<template>
  <section class="viewsrhqyBasicManage_serviceList p-4 space-y-4">
    <viewTitle
      title="业务管理 / 基础数据管理 / 预约业务管理"
      :showReturn="false"
    />
    <el-button
      v-has="['c-base-mp-business-add']"
      @click="onAdd"
      size="medium"
      type="primary"
      >添加</el-button
    >
    <div class="space-x-2">
      <span class="text-sm">预约业务名称</span>
      <el-input
        clearable
        v-model="queryParam.keyword"
        placeholder="请输入预约业务名称"
        class="w-60"
      ></el-input>
    </div>
    <c-table
      class="mt-4"
      id="coordinateManage"
      :isIndex="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      @loadPage="loadData"
    >
      <template slot="action" slot-scope="scope">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link
            v-has="['c-base-mp-business-update']"
            @click="onEdit(scope.row)"
            label="修改"
          ></c-link>
          <c-link
            v-has="['c-base-mp-business-delete']"
            @click="onDelete(scope.row)"
            label="删除"
            type="danger"
          ></c-link>
        </el-row>
      </template>
    </c-table>
    <serviceModal ref="serviceModal" @ok="onCreateOk" />
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import serviceModal from "./components/serviceModal.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      queryParam: {
        keyword: "", // 关键字搜索
        state: 0, // 状态
        is_parent: 0 // 是否是父级
      },
      columns: [
        {
          label: "基地",
          prop: "baseName",
          formatData: () => this.baseInfo.com_name
        },
        { label: "预约业务名称", prop: "name" },
        {
          label: "业务类型",
          prop: "type",
          formatData: row => {
            return row.type == 11
              ? "送货业务"
              : row.type == 12
              ? "提货业务"
              : "--";
          }
        },
        {
          label: "订单类型",
          prop: "order_type",
          formatData: row => {
            if (row.order_type === "CD") {
              return "木片";
            }
            if (row.order_type === "IB") {
              return "国废";
            }
            if (row.order_type === "NB") {
              return "化辅";
            }
            return row.order_type === "OTHER" ? "其他" : row.order_type || "--";
          }
        },
        {
          label: "预约提货类型",
          prop: "pickup_booking_type",
          formatData: row => {
            if (Number(row.type) !== 12) return "--";
            if (row.pickup_booking_type === "FINISHED") return "成品";
            if (row.pickup_booking_type === "TRI_WASTE") return "三废";
            return "其他";
          }
        },
        {
          label: "是否出车确认",
          prop: "need_depart_confirm",
          formatData: row => {
            return Number(row.need_depart_confirm) === 1 ? "需要" : "不需要";
          }
        },
        {
          label: "出车北斗校验",
          prop: "outward_beidou_check",
          formatData: row => {
            return Number(row.need_depart_confirm) === 1 &&
              Number(row.outward_beidou_check) === 1
              ? "开启"
              : "关闭";
          }
        },
        {
          label: "进出厂模式",
          prop: "access_mode",
          formatData: row => {
            return Number(row.access_mode) === 2
              ? "发卡退卡进出厂"
              : "过磅进出厂";
          }
        },
        {
          label: "推送地磅时机",
          prop: "pound_push_timing",
          formatData: row => {
            if (Number(row.access_mode) !== 1) {
              return "--";
            }
            if (row.pound_push_timing === "NONE") {
              return "不推送";
            }
            if (row.pound_push_timing === "REPORT") {
              return "登记时推送";
            }
            return "预约时推送";
          }
        },
        {
          label: "推送停车场",
          prop: "parking_lot_push_timing",
          formatData: row => {
            if (row.parking_lot_push_timing === "BOOKING") {
              return "预约时推送";
            }
            if (row.parking_lot_push_timing === "OUTWARD") {
              return "出车确认时推送";
            }
            return "不推送";
          }
        },
        {
          label: "停车场校验",
          prop: "parking_lot_space_intercept",
          formatData: row => {
            return Number(row.parking_lot_space_intercept) === 1 ? "开启" : "关闭";
          }
        },
        {
          label: "进厂后节点",
          prop: "post_entry_nodes",
          formatData: row => {
            const postEntryNodeTextMap = {
              SAMPLE: "取样",
              WATER: "测水"
            };
            return (row.post_entry_nodes || [])
              .map(item => postEntryNodeTextMap[item] || item)
              .join(" / ");
          }
        },
        {
          label: "指定进厂门岗",
          prop: "info_door_info",
          formatData: row => {
            return row.info_door_info.map(e => e.name).join(",");
          }
        },
        {
          label: "指定出厂门岗",
          prop: "out_door_info",
          formatData: row => {
            return row.out_door_info.map(e => e.name).join(",");
          }
        },
        { label: "操作", prop: "action", width: 120 }
      ],
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_business",
          data: params
        })
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  components: {
    serviceModal
  },
  mixins: [initListMinxin, mixinTableLyout],
  methods: {
    onAdd() {
      this.$refs.serviceModal.openModal();
    },
    onEdit(row) {
      this.$refs.serviceModal.openModal(row);
    },
    onDelete(row) {
      this.$confirm("确认删除预约业务？删除后数据将不可恢复！", "删除")
        .then(_ => {
          this.$common
            .http({
              url: "/api/queue/admin/delete_business",
              data: { id: row.id }
            })
            .then(() => {
              this.$common.pcToastSuccess(`已成功删除“${row.name}”业务。`);
              this.loadData();
            });
        })
        .catch(_ => {});
    },
    onCreateOk() {
      this.onSearch();
    }
  }
};
</script>
